import TaskInterfaces from './tasks';
import MeetingInterfaces from './meetings';
import Reminders from './reminders';
import Tags from './tags';

class CalendarActivities {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/calendar-activities`;
    this.apiClient = apiClient;

    this.tasks = new TaskInterfaces(this.basePath, this.apiClient);
    this.meetings = new MeetingInterfaces(this.basePath, this.apiClient);
    this.reminders = new Reminders(this.basePath, this.apiClient);
    this.tags = new Tags(basePath, this.apiClient);

  }

  async bootstrap(query, urlParameters) {

    const path = `${this.basePath}/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  async getPopulatedActivities(queryOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getPopulatedActivityById(activityId) {

    const path = `${this.basePath}/:activityId`;

    return this.apiClient.get(path, { activityId }, {});

  }

}

export default CalendarActivities;